import React, { createContext, useRef, useContext, useState } from 'react';

const Sidecontext = createContext();

export const SidebarProvider = ({ children }) => {
  const dashboardRef = useRef(null);
  const [isopen , setopen]= useState(false)

  const focusDashboard = () => {
    if (dashboardRef.current) {
      dashboardRef.current.focus();
      dashboardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  return (
    <Sidecontext.Provider value={{ dashboardRef, isopen ,focusDashboard ,setopen }}>
      {children}
    </Sidecontext.Provider>
  );
};

export const useDashboard = () => useContext(Sidecontext);
